
  import { useIntegrationDetailsStore } from '@/stores/integrationDetails';
  import Level from '@/ui/components/common/Level.vue';
  import { Icon } from '@/ui/components/icon/Icon';
  import NavbarDetails from '@/ui/components/integrations/details/NavbarDetails.vue';
  import StatusButton from '@/ui/components/integrations/details/StatusButton.vue';
  import UpgradeAlert from '@/ui/components/integrations/UpgradeAlert.vue';
  import { Loading } from '@/ui/components/Loading';
  import { PageTitle } from '@/ui/components/PageTitle';
  import { computed, defineComponent, ref, watch } from 'vue';

  export default defineComponent({
    components: {
      StatusButton,
      PageTitle,
      Level,
      UpgradeAlert,
      Loading,
      Icon,
      NavbarDetails,
    },
    props: {
      id: {
        type: String,
        required: true,
      },
    },
    setup(props) {
      const store = useIntegrationDetailsStore();
      const loading = ref(false);

      watch(() => props.id, () => {
        loading.value = true;
        store.init(props.id).then(() => { loading.value = false; });
      }, { immediate: true });

      const integration = computed(() => store.integration);
      const activated = computed(() => store.isActivated);

      return {
        loading,
        integration,
        activated,
      };
    },
  });
